/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/skeleton/custom-elements';

import { defineCustomElement as defineOsdsSkeleton } from '@ovhcloud/ods-stencil/components/skeleton/custom-elements/osds-skeleton.js';

export const OsdsSkeleton = /*@__PURE__*/createReactComponent<JSX.OsdsSkeleton, HTMLOsdsSkeletonElement>('osds-skeleton', undefined, undefined, defineOsdsSkeleton);
